// LLM generated - Model Claude 4 Sonnet
import { createStyles } from '@mantine/core';

type StyleParams = {
  variant?: 'other' | 'current';
};

export const useStyles = createStyles((theme, { variant = 'other' }: StyleParams) => ({
  leftAlignedButton: {
    padding: 0,
    maxWidth: 'fit-content',
    '& > div': {
      justifyContent: 'flex-start !important',
      alignItems: 'center',
      maxWidth: '100%',
    },
  },
  reactionsDisplay: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-start',
    gap: theme.other.spacing._2,
    maxWidth: '100%',
    flexWrap: 'nowrap',
    marginRight: theme.other.spacing._16,
  },
  reactionText: {
    fontSize: 14,
    lineHeight: '16px',
  },
  menuDropdown: {
    marginLeft: variant === 'current' ? -theme.other.spacing._4 : theme.other.spacing._16,
  },
  dropdown: {
    padding: 0,
    border: 'none',
    backgroundColor: 'transparent',
    boxShadow: 'none',
  },

  reactionsContainer: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.other.spacing._8,
    padding: `${theme.other.spacing._8}px ${theme.other.spacing._12}px`,
    backgroundColor: theme.white,
    border: `1px solid ${theme.colors.gray2[1]}`,
    borderRadius: /* eslint-disable-line local-rules/use-theme-tokens */ 20,
    boxShadow: theme.shadows.sm,
    maxWidth: 'fit-content',
  },

  reactionButton: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    minWidth: 32,
    height: 32,
    border: 'none',
    borderRadius: theme.other.spacing._6,
    backgroundColor: 'transparent',
    cursor: 'pointer',
    padding: theme.other.spacing._4,
    transition: 'background-color 0.2s ease',

    '&:hover': {
      backgroundColor: theme.colors.gray2[1],
    },

    '&:active': {
      backgroundColor: theme.colors.gray2[2],
    },

    '&:focus': {
      outline: `2px solid ${theme.colors.blue[9]}`,
      outlineOffset: 2,
    },
  },

  reactionImage: {
    width: 16,
    height: 16,
    maxWidth: 16,
    maxHeight: 16,
    objectFit: 'contain',
    flexShrink: 0,
  },
}));
